import { NavLink, Link } from 'react-router-dom';
import { Radio, Heart, History, Map } from 'lucide-react';
import { PRODUCT } from '@/config/product.config';
import { SyncStatusButton } from '@/components/sync/SyncStatusButton';
import { clsx } from 'clsx';

const navItems = [
  { to: '/', label: 'Harita', icon: Map, end: true },
  { to: '/favorites', label: 'Favoriler', icon: Heart, end: false },
  { to: '/history', label: 'Geçmiş', icon: History, end: false },
];

export function TopNav() {
  return (
    <header className="pointer-events-none absolute inset-x-0 top-0 z-30 flex items-center justify-between p-3 sm:p-4">
      {/* Brand */}
      <Link
        to="/"
        className="pointer-events-auto flex items-center gap-2 rounded-xl glass px-3 py-2 shadow-glow transition-transform hover:scale-[1.02]"
      >
        <Radio className="h-5 w-5 text-accent-400" />
        <span className="text-sm font-bold tracking-tight text-slate-50">
          {PRODUCT.name}
        </span>
      </Link>

      {/* Sync status */}
      <SyncStatusButton />

      {/* Nav links */}
      <nav
        aria-label="Ana navigasyon"
        className="pointer-events-auto flex items-center gap-1 rounded-xl glass p-1"
      >
        {navItems.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              clsx(
                'flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium transition-colors sm:px-3',
                isActive
                  ? 'bg-accent-500/20 text-accent-200'
                  : 'text-slate-300 hover:bg-white/10 hover:text-slate-100',
              )
            }
          >
            <Icon className="h-4 w-4" />
            <span className="hidden sm:inline">{label}</span>
          </NavLink>
        ))}
      </nav>
    </header>
  );
}
